import React, { Component } from 'react'
import { List } from 'immutable'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import SelectList from 'components/common/SelectList'
import { setActiveType } from 'reducers/seaLice/reducer'
import messages from 'components/Apps/SeaLiceMonitor/translate'
import * as SLHelper from 'helpers/seaLice'

class TypeFilter extends Component {
  onTypeChange = v => {
    if (v) {
      this.props.setActiveType(v.index)
    }
  }

  render() {
    const {
      activeType,
      intl: { formatMessage },
    } = this.props
    const types = SLHelper.TYPE_FILTER_LIST.map(({ id, title }) => ({
      id,
      title: formatMessage(messages[title]),
    }))

    return (
      <div className="caption-panel">
        <SelectList
          label={formatMessage(messages.type)}
          className="sealice-table-select"
          name="type"
          onChange={this.onTypeChange}
          list={List(types)}
          value={activeType}
          map={{
            index: 'id',
            text: 'title',
          }}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    activeType: state.getIn(['seaLice', 'activeType']),
  }),
  {
    setActiveType,
  },
)(injectIntl(TypeFilter))
